import { Component, Vue } from 'vue-property-decorator'
import { menuBtn } from '@/utils/menu_level2_button'
import { UserModule } from '@/store/modules/user'
import { formatDate } from '@/utils/timeFilter'
import { getProjectAllList, setProjectAllById, getProjectAllById, setProjectAllByIdList, projectAllExportData, delProjectAllById } from '@/api/projectList'
import { gettHeaderByType, settHeaderByType, getDeparmentList, getUserList } from '@/api/common'
import { delNullProperty } from "@/utils/index";
import { join } from 'lodash'

const projectTypeList = [
    { key: '全部', value: '' },
    { key: '国外小组科研', value: 1 },
    { key: '国内1对1', value: 2 },
    { key: '国外1对1', value: 3 },
    { key: '名校实验室', value: 4 },
    { key: 'AI HUB', value: 5 },
    { key: '全球华人导师', value: 6 },
    { key: '博雅计划-在线', value: 27 },
    { key: 'IEPQ线上项目', value: 30 },
    { key: '竞赛', value: 31 },
    { key: '全球华人导师-香港', value: 32 },
    {value: 38, key: '海外导师线下项目'},
    {value: 39, key: '国内导师线下项目'},
    {value: 40, key: '竞赛1v1'},
    {value: 42, key: 'IEPQ 1v1'},
    {value: 44, key: '全球华人导师-海外'},
    {value: 45, key: '企业导师远程实训'},
    {value: 47, key: '博雅计划-线下'},
    {value: 48, key: 'IEPQ 1v3'},
    {value: 49, key: '专业选修课'},
    {value: 50, key: 'IEPQ线下项目'},
    {value: 51, key: 'CERTIPORT认证课程'},
    {value: 52, key: '境外游学项目'},
    {value: 53, key: '竞赛线下（营地）'},
    {value: 54, key: '竞赛线下（研学）'},
]

@Component({
    filters: {
        typeFilter: (val: number) => {
            return projectTypeList.filter(item => item.value === val)[0].key
        }
    }
})
export default class AllProject extends Vue {
    page = 1
    limit = 20
    total = 0
    tableHeadPopoverShow = false
    draggableTableHeader = [] // 改变顺序所用的表头
    tableHeader = []
    tableData = []
    checkTableRow = []
    loading = false
    tableKey = Math.random()
    receiverUser = ''
    batchEditQuota = ''

    isShowUserList: string[] = []
    professionAndDirectionList = [
        {
            id: 7,
            name: '金融商科',
            permissionOrder: [
                { id: 9, name: '金融' },
                { id: 8, name: '商业' },
                { id: 10, name: '经济学' },
                { id: 26, name: '管理学' },
            ],
        },
        {
            id: 11,
            name: '理工科',
            permissionOrder: [
                { id: 12, name: '人工智能' },
                { id: 13, name: '计算机科学' },
                { id: 14, name: '工程' },
                { id: 15, name: '理学/自然科学' },
                { id: 16, name: '公共卫生与医学' },
            ],
        },
        {
            id: 17,
            name: '人文社科',
            permissionOrder: [
                { id: 18, name: '社会科学' },
                { id: 21, name: '教学与教育' },
                { id: 22, name: '法律' },
                { id: 20, name: '人文科学' },
                { id: 24, name: '艺术设计' }
            ],
        },
    ]
    projectTypeList = projectTypeList
    elCascaderProps = {
        expandTrigger: 'hover',
        multiple: true,
        value: 'id',
        label: 'name',
        children: 'permissionOrder'
    }

    filter_code = '' // 项目编号
    filter_projectName = '' // 项目名称
    filter_teacherName = '' // 导师名称
    filter_teacherLevel = '' // 导师级别
    filter_teacherSchool = '' // 导师学校
    filter_productOwner: string[] = [] // 产品负责人
    filter_teacherRealName= '' // 班主任
    filter_thesisName= '' // 论文班主任
    filter_littleHelper = '' //小助手
    filter_professionAndDirectionIdList: number[][] = [] // 方向专业
    filter_typeIdList: number | '' = '' //项目类型
    filter_status = '' // 状态
    filter_isShow = '' // 可见范围
    filter_curriculaTime = [] // 开课时间

    batchMakeVisibleDialog = false // 批量设置共享
    editQuotaErrorDialog = false // 修改名额失败
    editReceiverUserDialog = false // 批量修改负责人
    batchEditQuotaDialog = false // 批量修改名额
    deleteProjectId: number = null // 删除项目的ID
    deleteDialogShow = false // 删除项目的弹窗
    userListTree = [] //批量设置共享人员
    // 选择部门
    rangeSelectShow = false
    inRange = '部门'
    checkRangeUserList: Array<string> = [] // 适用范围内选中的员工 id
    checkRangeDepartmentList: Array<number> = [] // 适用范围内选中的部门 id
    checkUserInfo: any = [] // 选中的员工信息，主要用来回显在适用范围的输入框内，与后台返回的deparmentList、userList数据结构基本一致，方便渲染
    checkDeparmentInfo: any = [] // 选中的部门信息
    deparmentList: any = [] // 部门列表
    accessibleList: any = []
    departmentList: []
    userList: any = []
    types = ''
    searchName = '' // 搜索的关键字
    exportButtonDisabled = false
    timer = null
    // isReadonly = false
    draggableListChange = []
    vdaH = 0 //屏幕高度
    popHeight = 0
    userList1 = []

    buttonShow = menuBtn

    get userListNew() {
        return UserModule.userList
    }

    get schoolBegin() {
        let str = ''
        if(!this.filter_curriculaTime || this.filter_curriculaTime.length === 0) {
            str = ''
        } else {
            str = formatDate('yyyy-MM-dd', new Date(this.filter_curriculaTime[0])) + '/' + formatDate('yyyy-MM-dd', new Date(this.filter_curriculaTime[1]))
        }
        return str
    }

    created() {
        this.getTableHeader()
        this.getTableData()
        this.getUserList()
        // this.handleFocusTypes('')
        const h = document.documentElement.clientHeight || document.body.clientHeight;
        this.vdaH = h - 260 ;
        this.popHeight = this.vdaH
    }
    mounted(){
        document.addEventListener('click', (e)=> {
            if ((e.target as HTMLInputElement).className != 'el-input__inner') {
                this.rangeSelectShow= false;
            }
        })
    }



    // 生成 共享人员
    projectShowName(userList: any[], deparmentList: any[]) {
        let value = ''
        if(userList && userList.length > 0) {
            value = userList.map(item => item.userRealName).join(', ')
        }
        if(deparmentList && deparmentList.length > 0) {
            value && (value += ', ')
            value += deparmentList.map(item => item.departmentName).join(', ')
        }
        return value
    }
    async handleFocusTypes(type){
        this.types = type
        const data: any = await getUserList(delNullProperty({ types: this.types }))
        this.userList = data
    }
    async getUserList(name?: string) {
        const data: any = await getUserList(delNullProperty({ name }))
        this.userListTree = data
    }
    async getDeparment(name?: string) {
        const data: any = await getDeparmentList({ name })
        this.deparmentList = data
    }
    changeCheckUserInfo(item: { id: string; realName: string }, bol: boolean) {
        if (bol) {
            this.checkUserInfo.push({
                'userId': item.id,
                'user': item
            })
        } else {
            this.checkUserInfo = this.checkUserInfo.filter(user => user.userId !== item.id)
        }
        this.userList = this.checkUserInfo
    }
    chooseDepartment(checkedKeys) {
        // 取消勾选
        const [accessibleList] = [this.accessibleList, (this.$refs.tree as HTMLFormElement).getCheckedKeys()];
        // 循环删除this.accessibleList中的项
        for (const i in accessibleList) {
            if (accessibleList[i].id == checkedKeys.id) {
                this.accessibleList.splice(i, 1);
                return;
            }
        }
        // 添加勾选
        const [arr, newArr] = [[], (this.$refs.tree as HTMLFormElement).getCheckedKeys()];
        arr.push(checkedKeys);
        function dealData(arr, newArr) {
            for (const i in arr) {
                newArr.push(arr[i].id);
                dealData(arr[i].children, newArr);
            }
        }
        // newArr代表获取出来的当前节点以及其下的所有子节点的id
        dealData(arr, newArr);
        (this.$refs.tree as HTMLFormElement).setCheckedKeys(newArr);
        // newJsonArr代表所有选中的节点
        const newJsonArr = (this.$refs.tree as HTMLFormElement).getCheckedNodes();
        this.accessibleList = newJsonArr;
        this.checkDeparmentInfo = []
        newJsonArr.map(item => {
            this.checkDeparmentInfo.push({
                department: {
                    name: item.name,
                    detail: null,
                    id: item.id
                },
                departmentId: item.id
            })
        })
        this.checkDeparmentInfo.forEach((item) => {
            //动态向List中每个对象添加autoHeight属性
            this.$set(item, "autoHeight", "2rem");
        });
    }
    changeInRange(type: string) {
        this.inRange = type
        this.searchName = ''
        this.$forceUpdate()
        this.getUserList()
        this.getDeparment()
    }
    clearRangeDeparmentItem(id: number) {
        const arr = []
        this.checkDeparmentInfo = this.checkDeparmentInfo.filter((item: any) => item.departmentId != id);
        for (const i in this.checkDeparmentInfo) {
            arr.push(this.checkDeparmentInfo[i].department)
        }
        (this.$refs.tree as HTMLFormElement).setCheckedNodes(arr)
    }
    clearRangeUserItem(id: string) {
        this.checkRangeUserList.splice(this.checkRangeUserList.indexOf(id), 1)
        this.checkUserInfo = this.checkUserInfo.filter((item: any) => item.userId != id);
        this.userList = this.checkUserInfo
    }


    onSearchName() {
        if (this.inRange === '部门') this.getDeparment(this.searchName)
        if (this.inRange === '员工') this.getUserList(this.searchName)
    }

    treeChange(item: any, itembol: boolean) {
        if (itembol) {
            const res = (this.$refs.tree as HTMLFormElement).getCheckedNodes()
            const arrDeptId = []
            res.forEach((item) => {
                arrDeptId.push({
                    department: {
                        name: item.name,
                        detail: null,
                        id: item.id
                    },
                    departmentId: item.id
                })
            })
            this.checkDeparmentInfo = arrDeptId
        } else {
            this.checkDeparmentInfo.map((t: any, i: number) => {
                if (t.departmentId === item.id) {
                    this.checkDeparmentInfo.splice(i, 1)
                }
            });
        }
        this.departmentList = this.checkDeparmentInfo
    }
    handleAddDeparment() {
        this.getDeparment()
        this.rangeSelectShow = true
        this.getUserList('')
        this.inRange = '部门'
    }
    handleClose(done) {
        this.rangeSelectShow = false
    }
    async getTableData() {
        this.loading = true

        const param = {
            code: this.filter_code,
            name: this.filter_projectName,
            teacherName: this.filter_teacherName,
            teacherLevel: this.filter_teacherLevel,
            teacherSchool: this.filter_teacherSchool,
            userIdList: this.filter_productOwner,
            teacherUserId: this.filter_teacherRealName, // 班主任
            thesisUserId: this.filter_thesisName, // 论文班主任
            helperUserId: this.filter_littleHelper,  //小助手
            professionAndDirectionList: this.filter_professionAndDirectionIdList,
            typeId: this.filter_typeIdList,
            status: this.filter_status,
            isShow: this.filter_isShow,
            schoolBegin: this.schoolBegin,
            page: this.page,
            limit: this.limit
        }
        for (const key in param) {
            if (!param[key] || param[key].length === 0) delete param[key]
        }
        const data: any = await getProjectAllList(param)
        this.tableData = data.projectAllList
        this.total = data.allNum
        this.loading = false
        // this.isReadonly = false
        this.tableKey = Math.random()
        this.$nextTick(() => {
            (this.$refs.multipleTable as HTMLFormElement).doLayout();
            (this.$refs.multipleTable as HTMLFormElement).bodyWrapper.scrollTop = 0;
        });
    }

    async getTableHeader() {
        const data: any = await gettHeaderByType(5)
        this.tableHeader = data.headerUserList
        this.draggableTableHeader = JSON.parse(JSON.stringify(data.headerUserList))
        this.draggableListChange = JSON.parse(JSON.stringify(data.headerUserList))
        this.getTableData()
    }
    handleShare() {
        this.batchMakeVisibleDialog = true
        this.searchName = ''
        this.$nextTick(() => {
            (this.$refs.tree as HTMLFormElement).setCheckedKeys([]);
        });
        this.checkDeparmentInfo = []
        this.checkUserInfo = []
        this.checkRangeUserList = []
        this.getUserList('')
        this.inRange = '部门'
    }
    async confirmBatchMakeVisible() {
        const isShowDepartmentIdList = []
        this.checkDeparmentInfo.map(item => {
            isShowDepartmentIdList.push(item.departmentId)
        })
        const isShowUserIdList = []
        this.checkUserInfo.map(item => {
            isShowUserIdList.push(item.userId)
        })
        const obj = {
            isShowDepartmentIdList: isShowDepartmentIdList,
            isShowUserIdList: isShowUserIdList,
            idList: this.checkTableRow.map(item => item.id),
        }
        if (isShowUserIdList.length > 0 || isShowDepartmentIdList.length > 0) {
            await setProjectAllByIdList(obj)
            this.$message.success('修改共享范围成功')
            this.getTableData()
            this.checkTableRow = []
            this.isShowUserList = []
            this.batchMakeVisibleDialog = false
        } else {
            this.$message.error('请设置共享人员')
        }


    }

    async confirmEditReceiverUser() {
        if (!this.receiverUser) {
           this.$message.error('负责人不能为空')
            return
        }
        await setProjectAllByIdList({
            idList: this.checkTableRow.map(item => item.id),
            userId: this.receiverUser,
        })
        this.$message.success('修改负责人成功')
        this.getTableData()
        this.receiverUser = ''
        this.checkTableRow = []
        this.editReceiverUserDialog = false
    }

    async confirmBatchEditQuota() {
       if(!this.batchEditQuota){
           this.$message.error('满班名额不能为空')
           return
       }
        await setProjectAllByIdList({
            idList: this.checkTableRow.map(item => item.id),
            quota: this.batchEditQuota ? Number(this.batchEditQuota) : ''
        })
        this.$message.success('修改满班名额成功')

        this.getTableData()
        this.batchEditQuota = ''
        this.checkTableRow = []
        this.batchEditQuotaDialog = false
    }

    async handleEditQuota(){
        this.getTableData()
        this.editQuotaErrorDialog = false
    }
    checkEditQuoa(row) {
        if (row.quota < row.haveQuota) {
            this.editQuotaErrorDialog = true
            return
        }
        // const obj = {
        //     id: row.id,
        //     quota: Number(row.quota),
        //     isShowUserIdList: row.projectAllShowUserList.map(item => item.userId),
        //     isShowDepartmentIdList: row.projectAllShowDepartmentList.map(item => item.departmentId),
        //     isShow: row.isShow
        // }
        // if (row.isShow !== '共享人员') {
        //     delete obj.isShowUserIdList
        //     delete obj.isShowDepartmentIdList
        // }
        // setProjectAllById(obj).then(res => {
        //     this.$message.success('修改名额成功')
        //     row.surplusQuota = row.quota - row.haveQuota
        // }).catch(async err => {
        //     const data: any = await getProjectAllById(row.id)
        //     row.quota = data.projectAll.quota
        // }) 2024-1-5替换接口为批量修改满班名额

        setProjectAllByIdList({
            idList: [row.id],
            quota: Number(row.quota)
        }).then(res => {
            this.$message.success('修改名额成功')
            row.surplusQuota = row.quota - row.haveQuota
        }).catch(async err => {
            const data: any = await getProjectAllById(row.id)
            row.quota = data.projectAll.quota
        })
    }

    handleSelectionChange(arr: any) {
        this.checkTableRow = arr
    }

    clickCluesStatisticsData() {
        window.open(window.location.origin + this.$route.matched[0].path + '/allProjectStatisticalData', '_blank')
    }

    async exportData() {
        this.exportButtonDisabled = true
        this.$message.success('数据已转入后台导出, 请前往下载列表查看')
        projectAllExportData(delNullProperty({
            code: this.filter_code,
            name: this.filter_projectName,
            teacherName: this.filter_teacherName,
            teacherLevel: this.filter_teacherLevel,
            teacherSchool: this.filter_teacherSchool,
            userIdList: this.filter_productOwner,
            teacherUserId: this.filter_teacherRealName, // 班主任
            thesisUserId: this.filter_thesisName, // 论文班主任
            helperUserId: this.filter_littleHelper, //小助手
            professionAndDirectionList: this.filter_professionAndDirectionIdList,
            typeId: this.filter_typeIdList,
            status: this.filter_status,
            isShow: this.filter_isShow,
            schoolBegin: this.schoolBegin,
        })).then(() => {
            this.exportButtonDisabled = false
        }).catch(() => [
            this.exportButtonDisabled = false
        ])
    }
    changeTable() {
        const newArr = []
        this.draggableListChange.forEach(item => {
            if (item.isShow === true) {
                newArr.push(item)
            }
        })
        if (newArr.length == 1) {
            newArr.forEach(item => {
                item.isDisBtn = true
            })
        } else {
            newArr.forEach(item => {
                item.isDisBtn = false
            })
        }
    }
    async draggableEnd() {
        this.tableHeadPopoverShow = false
        this.draggableTableHeader = this.draggableListChange
        const newArr: object = this.draggableTableHeader.filter(item =>
            item.isShow === true
        )
        if ((newArr as []).length > 0) {
            await settHeaderByType({
                types: 5,
                headerIds: this.draggableTableHeader
            })
            this.$message.success('修改表头顺序成功')
            this.getTableHeader()
            // this.tableKey = Math.random()
        } else {
            this.$message.error('至少保留一个表头')
        }
    }

    doCancel(){
        this.draggableListChange = JSON.parse(JSON.stringify( this.draggableTableHeader))
        this.tableHeadPopoverShow = false
    }



    clickEditButton(row) {
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/allProjectInfo?id=' + row.id + '&type=' + 1, '_blank')
        const timer = setInterval(() => {
            if (win.closed) {
                clearInterval(timer)
                this.getTableData()
            }
        }, 500)
    }
    // 报名学员
    handleEnrollStudents(row) {
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/allProjectStudent?id=' + row.id + '&type=' + 1, '_blank')
        const timer = setInterval(() => {
            if (win.close) {
                clearInterval(timer)
                this.getTableData()
            }
        }, 500)
    }

    clickProjectName(row) {
        if (!this.buttonShow(47)) return
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/allProjectInfo?id=' + row.id + '&type=' + 0, '_blank')
        const timer = setInterval(() => {
            if (win.close) {
                clearInterval(timer)
                this.getTableData()
            }
        }, 500)
    }

    // 点击删除按钮
    clickDeleteBtn(row) {
        this.deleteProjectId = row.id
        this.deleteDialogShow = true
    }

    // 确认删除项目
    async confirmDeleteProject() {
        await delProjectAllById({ id: this.deleteProjectId })
        this.deleteProjectId = null
        this.deleteDialogShow = false
        this.$message.success("删除项目成功")
        this.getTableData()
    }

    pageChange(page: number) {
        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.page = page
            this.getTableData()
        }, 1000)
    }
    limitChange(limit: number) {
        this.limit = limit
        this.getTableData()
    }

    hideUser(){
        this.userList1 = []
    }
    userListFocus() {
        this.userList1 = this.userListNew
    }

}
